/* -------------------------------------------------------
   PromptChips — Pre-defined scenario prompt buttons
   grouped by Tax Insights & Portfolio Analysis.
   ------------------------------------------------------- */

import React from 'react';

interface ChipGroup {
  label: string;
  icon: string;
  chips: string[];
}

const GROUPS: ChipGroup[] = [
  {
    label: 'Tax Insights',
    icon: '',
    chips: [
      'Summarize my realized gains YTD',
      'Find me tax saving opportunities(TLH)',
      'Want to liquidate $25k for house downpayment',
      'Show my wash sales to avoid this month',
    ],
  },
  {
    label: 'Portfolio Analysis',
    icon: '',
    chips: [
      'What is my asset allocation?',
      'Am I too concentrated in one stock or sector?',
      'What are my risky bets?',
      'How exposed am I to AI themes?',
    ],
  },
];

interface Props {
  onSelect: (text: string) => void;
}

const PromptChips: React.FC<Props> = ({ onSelect }) => (
  <div className="cv2-chips" role="region" aria-label="Suggested prompts">
    {GROUPS.map((g) => (
      <div key={g.label} className="cv2-chips-group">
        <span className="cv2-chips-label">
          {g.icon ? `${g.icon} ` : ''}{g.label}
        </span>
        <div className="cv2-chips-list cv2-chips-list--vertical" role="list">
          {g.chips.map((c) => (
            <button
              key={c}
              className="cv2-chip-btn"
              role="listitem"
              onClick={() => onSelect(c)}
              aria-label={`Ask: ${c}`}
            >
              {c}
            </button>
          ))}
        </div>
      </div>
    ))}
  </div>
);

export default React.memo(PromptChips);
